module.exports = __webpack_public_path__ + "static/img/mkv.16d2fe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/mkv.png
// module id = 5y7B
// module chunks = 53